<template>
  <div class="dynamic-field-container">
    <label>{{ field.label }}</label>
    <el-input
      :data-vv-as="fieldName"
      data-vv-validate-on="blur"
      :name="fieldName"
      class="fifty-percent"
      v-model="proxyValue"
      v-validate="fieldValidationRules"
      :disabled="isTaskFieldDisabled"
      :placeholder="field.placeholder"></el-input>
    <small class="text-danger" v-show="errors.has(fieldName)" style="display:block; margin-top: 7px;">
      {{ getError(fieldName) }}
    </small>
  </div>
</template>

<script>
  import {generateDynamicFieldValidation, canEditTaskField} from 'src/utilities/utils'

  export default {
    inject: ['$validator'],
    props: ['field', 'value', 'commit', 'task', 'disabled'],
    fieldName: 'temp',
    computed: {
      fieldValidationRules() {
        // expressions override other validation logic
        if (this.field.expression) {
          this.fieldValidation = function(str) {
            return eval(str).apply(this)
          }.call(this, this.field.expression)
        }
        return this.fieldValidation
      },
      proxyValue: {
        get() {
          return this.value
        },
        set(newValue) {
          this.$store.commit(this.commit, { key: this.field.key, value: newValue })
        }
      },
      isTaskFieldDisabled() {
        if (this.disabled) {
          return true
        }
        return !canEditTaskField(this)
      }
    },
    data() {
      return {
        fieldValidation: {},
        statusOnLoad: null
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      }
    },
    created() {
      generateDynamicFieldValidation(this)
    },
    mounted() {
      // cache field instance.
      this.$field = this.$validator.fields.find({ name: this.fieldName })
      this.statusOnLoad = JSON.parse(JSON.stringify(this.task.status))
    },
    watch: {
      fieldName(value) {
        // update the field name.
        this.$field.update({ name: value })
      }
    }
  }
</script>

<style scoped>
  label {
    display: block;
  }
  .dynamic-field-container {
    margin-bottom: 10px;
  }
  .fifty-percent {
    width: 50%
  }
</style>
